import React, { Component } from 'react'
import moment from 'moment'
import { Label } from 'semantic-ui-react'

import utils from '../../utils'

export default class DriverPendingTimer extends Component {
  state = { remaining: 0 }

  componentDidMount() {
    const { expiredAt } = this.props

    clearInterval(this.timer)

    this.calculateRemaining(expiredAt)
  }

  componentWillReceiveProps(nextProps) {
    const { expiredAt, driverTel } = this.props

    if (expiredAt !== nextProps.expiredAt || driverTel !== nextProps.driverTel) {
      clearInterval(this.timer)
      this.calculateRemaining(nextProps.expiredAt)
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  calculateRemaining = expiredAt => {
    const now = moment()
    const willExpired = moment(Number(expiredAt))
    const remaining = willExpired.diff(now, 'seconds')

    this.setState({ remaining }, this.countdown)
  }

  countdown = () => {
    this.timer = setInterval(() => {
      const { remaining } = this.state

      if (remaining > 0) {
        this.setState({ remaining: remaining - 1 })
      } else {
        this.setState({ remaining: 0 })
      }
    }, 1000)
  }

  render() {
    const { hasDivider, driverTel, driverName } = this.props
    const { remaining } = this.state
    const callableDriverTel = utils.helpers.convertToLocalPhoneNumber(driverTel)

    if (remaining <= 0) return null

    return (
      <React.Fragment>
        {hasDivider && <hr style={{ margin: '10px 0px 5px 0px' }} key="hr-line" />}
        <div>
          <strong>{driverName}</strong>
        </div>

        <div>
          <a href={utils.helpers.convertToCallableLink(callableDriverTel)}>
            <Label style={{ margin: 0, marginTop: 5, width: 120 }}>{driverTel}</Label>
          </a>
        </div>

        <Label color="orange" style={{ margin: 0, marginTop: 5, width: 120 }}>
          <div style={{ marginBottom: 3 }}>Waiting Driver</div>
          <div>{`${remaining}s`}</div>
        </Label>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/DriverPendingTimer.js